const PortfolioPrpos = [
    {
        id: "1",
        title: "Web Designing",
        imgSrc: "imgs/folio-1.jpg",
        category: "Web Templates",
    },
    {
        id: "2",
        title: "Graphic Designing",
        imgSrc: "imgs/folio-2.jpg",
        category: "Graphic Templates",
    },
    {
        id: "3",
        title: "WordPress Designing",
        imgSrc: "imgs/folio-3.jpg",
        category: "WordPress Templates",
    },
]

export default PortfolioPrpos;